<template>
  <div class="page-content">
    <div class="cinema-daily">
      <h1 class="page-title">{{ $locale("sideMenu.reports.cinemaDaily") }}</h1>

      <!-- Search Area -->
      <el-form :model="onSearch" label-position="top" :rules="formRules">
        <el-row style="margin-top: 20px;">
          <el-col :span="6">
            <el-form-item :label="$locale('report.cinemaDaily.businessMonth')" prop="monthDate">
              <CommDatePicker
                v-model="onSearch.monthDate"
                :value.sync="onSearch.monthDate"
                width="100%"
                type="month"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item :label="$locale('global.cinema')" prop="cinemaId">
                <el-select v-model="onSearch.cinemaId">
                  <el-option v-for="item in cinemaOption" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item style="margin-top: 40px;">
              <el-button class="egl-btn-yellow" @click="openDownloadDailog" :disabled="btnDisabled">
                {{ $locale("global.download") }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <hr class="dotted" />

      <el-dialog
        :title="$locale('sideMenu.reports.cinemaDaily')"
        :visible="dialogShow"
        width="96%"
        class="egl-dialog-elm cinema-daily-pdf-dialog"
        :before-close="closeDialog"
        destroy-on-close
        lock-scroll
        append-to-body
        :close-on-click-modal="false"
      >
        <section class="pdf-viewer clearfix" v-if="dialogShow">
          <div class="ctrl-btns-row noprint">
            <el-button type="info" icon="el-icon-s-promotion">{{ $locale("pdf.sendEmail") }}</el-button>
            <el-button icon="el-icon-document" class="egl-btn-yellow" @click="downloadPdf">{{ $locale("pdf.pdf") }}</el-button>
            <el-button type="info" icon="el-icon-printer" @click="printAction">{{ $locale("pdf.print") }}</el-button>
          </div>

          <section class="pdf-container cinema-daily-pdf">
            <div class="content-preview">
              <vue-html2pdf
                :show-layout="converterSetting.showLayout"
                :float-layout="converterSetting.floatLayout"
                :enable-download="converterSetting.enableDownload"
                :preview-modal="converterSetting.previewModal"
                :paginate-elements-by-height="converterSetting.paginateElementsByHeight"
                :filename="converterSetting.filename"
                :pdf-quality="converterSetting.pdfQuality"
                :manual-pagination="converterSetting.manualPagination"
                :pdf-format="converterSetting.pdfFormat"
                :pdf-orientation="converterSetting.pdfOrientation"
                :pdf-content-width="converterSetting.pdfContentWidth"
                :html-to-pdf-options="{
                  html2canvas: {
                    width: 1190,
                  },
                  jsPDF: {
                    format: 'a3',
                    orientation: 'landscape',
                  },
                  filename: converterSetting.filename
                }"
                ref="html2Pdf"
                @startPagination="showLoading"
                @hasDownloaded="savePDFtoServer"
              >
                <section slot="pdf-content">
                  <!-- PDF Content Here -->
                  <section class="cinema-daily-pdf-sample">
                    <div class="pdf-content-container">
                      <i tabindex="0" hidefocus="true" id="pageTop" class="page-top-point"></i>
                      <section class="page-container cinema-daily-page-container" v-show="printMode || currentPage === 1" :style="printMode ? 'box-shadow:none' : ''">
                        <section class="invoice-header">
                          <h1>{{ $locale("sideMenu.reports.cinemaDaily") }}</h1>
                          <el-row class="pdf-header-content">
                            <el-col :span="12">
                              <el-row>
                                <el-col :span="24">{{ $locale("report.cinemaDaily.businessMonth") }}：{{ $moment(onSearch.monthDate).format("YYYY-MM") }}</el-col>
                                <el-col :span="24">{{ $locale("global.cinemaName") }}：{{ pdf.cinemaName }}</el-col>
                                <el-col :span="24">{{ $locale("report.cinemaDaily.manager") }}：{{ pdf.manager }}</el-col>
                              </el-row>
                            </el-col>
                            <el-col :span="12" class="ta-r stamp-area">
                              <p>{{ $locale("global.create") }}：{{ pdf.exportTime }}</p>
                              <el-row>
                                <el-col :span="12" style="border-right: 1px solid #181818;">
                                  <p>{{ $locale("report.cinemaDaily.managerMan") }}</p>
                                  <div class="stamp-img"></div>
                                </el-col>
                                <el-col :span="12">
                                  <p>{{ $locale("report.cinemaDaily.headquarter") }}</p>
                                  <div class="stamp-img"></div>
                                </el-col>
                              </el-row>
                            </el-col>
                          </el-row>
                        </section>

                        <section class="invoice-body">
                          <div class="invoice-deatils">
                            <PDFTable :data="pageListData(0)" v-bind:startYear="startYear"></PDFTable>
                          </div>
                        </section>

                        <section class="invoice-footer">
                          <div class="pagination"> {{ currentPage }} / {{ totalPages }} </div>
                        </section>

                        <div class="html2pdf__page-break" v-if="currentPage < totalPages"></div>
                      </section>

                      <template v-if="totalPages > 1">
                        <section class="page-container cinema-daily-page-container" v-for="page in totalPages - 1" :key="`page_${page}`" v-show="(printMode || currentPage === page + 1)">
                          <section class="invoice-body">
                            <div class="invoice-deatils">
                              <PDFTable :data="pageListData(page)" v-bind:startYear="startYear"></PDFTable>
                            </div>
                          </section>
                          <section class="invoice-footer">
                            <div class="pagination"> {{ currentPage }} / {{ totalPages }} </div>
                          </section>

                          <div class="html2pdf__page-break" v-if="currentPage < totalPages"></div>
                        </section>
                      </template>
                    </div>

                    <section class="pager-ctrl-row" v-show="!printMode">
                      <el-button
                        icon="el-icon-arrow-left"
                        class="egl-btn-yellow"
                        :disabled="isFirstPage"
                        @click="pageChangeAction(-1)"
                      ></el-button>
                      <el-button
                        icon="el-icon-arrow-right"
                        class="egl-btn-yellow"
                        :disabled="isLastPage"
                        @click="pageChangeAction(1)"
                      ></el-button>
                    </section>
                  </section>
                </section>
              </vue-html2pdf>
            </div>
          </section>
        </section>

        <div slot="footer" class="dialog-footer">
          <el-button class="egl-btn-white" @click="closeDialog">{{ $locale("global.cancel") }}</el-button>
          <el-button class="egl-btn-yellow" @click="closeDialog">{{ $locale("global.save") }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import "@/assets/style/cinemaDaily.less";
import CommDatePicker from "@/components/common/CommDatePicker/index.vue";
import { getCinemaList } from "@/helpers/service/api/common.js";
import { getCinemaDailyReport } from "@/helpers/service/api/report.js";
import VueHtml2pdf from "vue-html2pdf";
import PDFTable from "@/components/Report/CinemaDailyPdfTable.vue";
import { Loading } from "element-ui";
import { weekLocaleArray, rounding } from "@/utils/common";

const week = [ ...weekLocaleArray ];

export default {
  name: "CinemaDaily",
  components: {
    CommDatePicker,
    VueHtml2pdf,
    PDFTable,
  },
  data() {
    return {
      onSearch: {
        monthDate: this.$moment().startOf("month").valueOf(),
        cinemaId: this.cinemaId,
      },
      cinemaOption: [],
      dialogShow: false,
      converterSetting: {
        showLayout: true,
        floatLayout: false,
        enableDownload: true,
        previewModal: true,
        paginateElementsByHeight: 840,
        filename: this.$locale("sideMenu.reports.cinemaDaily"),
        pdfQuality: 1,
        manualPagination: true,
        pdfFormat: "a3",
        pdfOrientation: "landscape",
        pdfContentWidth: "1190px",
      },
      currentPage: 1,
      totalPages: 1,
      printMode: false,
      pdf: {
        firstDay: "",
        cinemaName: "",
        manager: "",
      },
      tableData: [],
      startYear: "",
      defaultPageSize: 42, //CR: At least include whole month dataz & 4 スクリーン別上映回数 & 月計 info
      formRules: {
        monthDate: [ {
          required: true,
          message: this.$locale("form.plsSelectDate"),
          trigger: "blur",
        } ],
        cinemaId: [ {
          required: true,
          message: this.$locale("form.plsSelectCinema"),
          trigger: "change",
        } ],
      },
    };
  },
  computed: {
    ...mapState("app", {
      cinemaId: state => state.cinemaId,
      brandId: state => state.brandId,
      cinemaObj: state => state.cinemaObj,
    }),
    isFirstPage() {
      return this.currentPage === 1;
    },
    isLastPage() {
      return this.currentPage === this.totalPages;
    },
    btnDisabled() {
      return Object.values(this.onSearch).some(_val => Boolean(_val) === false);
    },
  },
  created() {
  },
  mounted() {
    this.getCinemaOption();
  },
  methods: {
    getDate(obj) {
      this.onSearch = { ...this.onSearch, ...obj };
    },
    getCinemaOption() {
      if (this.cinemaId) {
        this.onSearch.cinemaId = this.cinemaId;

        const _cinemaOption = this.cinemaObj.find(_item => _item.id === this.cinemaId);
        this.cinemaOption = [ _cinemaOption ].map(_option => ({
          id: _option.id,
          name: _option.name
        }));
      } else {
        getCinemaList({
          brandId: this.brandId,
          page: 0,
          pageSize: 9999,
        }).then(res => {
          const _cinemaOption = res.data ? res.data.data || [] : [];
          this.cinemaOption = _cinemaOption.map(_option => ({
            id: _option.id,
            name: _option.name
          }));
        });
      }
    },
    openDownloadDailog() {
      const {
        cinemaId,
        monthDate,
      } =  this.onSearch;

      if (!cinemaId) { return; }

      const requestParam = {
        cinemaId,
        monthDate: this.$moment(monthDate).format("YYYY-MM-DD"),
      };

      getCinemaDailyReport(requestParam).then(res => {
        if (res.success) {
          const year = this.$locale("global.year");
          const month = this.$locale("global.month");
          let firstDay = this.$moment(res.data.reportAt).format("YYYY-MM-DD");
          let exportTime = this.$moment(res.data.exportAt).format("YYYY/MM/DD HH:mm:ss");
          let tableData = this.formatTableData(res.data);
          let totalPages = 1;

          firstDay = firstDay.replace("-", year);
          firstDay = firstDay.replace("-", month);
          firstDay = firstDay + "（" + week[this.$moment(res.data.reportAt).day()] + "）";

          if (tableData.length > this.defaultPageSize) {
            totalPages = Math.ceil((tableData.length - this.defaultPageSize) / this.defaultPageSize) + 1;
          }

          this.dialogShow = true;
          this.pdf = {
            firstDay: firstDay,
            cinemaName: res.data.cinema,
            manager: res.data.managerName,
            exportTime: exportTime,
          };
          this.tableData = tableData;
          this.startYear = this.$moment(monthDate).format("YYYY") + year;
          this.currentPage = 1;
          this.totalPages = totalPages;
        }
      });
    },
    closeDialog() {
      this.dialogShow = false;
    },
    printAction() {
      this.changePrintMode(true);

      this.$nextTick(function() {
        window.print();
      });
    },
    downloadPdf() {
      this.changePrintMode(true);
      this.$refs.html2Pdf.generatePdf();
    },
    changePrintMode(status) {
      this.setPrintMode(status);
    },
    setPrintMode(status) {
      this.currentPage = 1;
      this.printMode = status;
    },
    showLoading() {
      this.loadingStatus = Loading.service({
        text: `${this.$locale("global.loading")}...`,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      });
    },
    savePDFtoServer() {
      this.hideLoading();
    },
    hideLoading() {
      if (this.loadingStatus) {
        this.loadingStatus.close();
        this.loadingStatus = null;
      }

      this.changePrintMode(false);
    },
    pageChangeAction(step) {
      this.currentPage += step;
      const pageTop = document.getElementById("pageTop");
      pageTop.focus();
    },
    pageListData(page) {
      const startCount = page * this.defaultPageSize;
      const lists = [ ...this.tableData.slice(startCount, startCount + this.defaultPageSize) ];
      return [ ...lists ];
    },
    formatTableData(obj) {
      let newArr = [];
      let totalObj = {
        paidMobilization: 0,
        freeMobilization: 0,
        boxOfficeAmount: 0,
        ticketBudgetAchievementRate: 0,
        programAmount: 0,
        commercialAmount: 0,
        concessionAmount: 0,
        membershipFreeAmount: 0,
        otherAmount: 0,
        totalAmount: 0,
        goodsBudgetAchievementRate: 0,
        preSaleAmount: 0,
        dailyCash: 0,
        preCash: 0,
      };

      obj.dailyRecords.map(item => {
        newArr.push({
          dayDate: this.$moment(item.dayDate).format("MM/DD"),
          day: week[this.$moment(item.dayDate).day()],

          paidMobilization: item.paidMobilization.toLocaleString(),
          freeMobilization: item.freeMobilization.toLocaleString(),
          boxOfficeAmount: item.boxOfficeAmount.toLocaleString(),
          ticketBudgetAchievementRate: item.ticketBudgetAchievementRate,
          programAmount: item.programAmount.toLocaleString(),
          commercialAmount: item.commercialAmount.toLocaleString(),
          concessionAmount: item.concessionAmount.toLocaleString(),
          membershipFreeAmount: item.membershipFreeAmount.toLocaleString(),
          otherAmount: item.otherAmount.toLocaleString(),
          totalAmount: item.totalAmount.toLocaleString(),
          goodsBudgetAchievementRate: item.goodsBudgetAchievementRate,
          preSaleAmount: item.preSaleAmount.toLocaleString(),
          dailyCash: item.dailyCash.toLocaleString(),
          preCash: item.preCash.toLocaleString(),
        });

        totalObj.paidMobilization += item.paidMobilization;
        totalObj.freeMobilization += item.freeMobilization;
        totalObj.boxOfficeAmount += item.boxOfficeAmount;
        // totalObj.ticketBudgetAchievementRate += item.ticketBudgetAchievementRate;
        totalObj.programAmount += item.programAmount;
        totalObj.commercialAmount += item.commercialAmount;
        totalObj.concessionAmount += item.concessionAmount;
        totalObj.membershipFreeAmount += item.membershipFreeAmount;
        totalObj.otherAmount += item.otherAmount;
        totalObj.totalAmount += item.totalAmount;
        // totalObj.goodsBudgetAchievementRate += item.goodsBudgetAchievementRate;
        totalObj.preSaleAmount += item.preSaleAmount;
        totalObj.dailyCash += item.dailyCash;
        totalObj.preCash += item.preCash;
      });
      // totalObj.ticketBudgetAchievementRate = totalObj.ticketBudgetAchievementRate / obj.dailyRecords.length;
      // totalObj.goodsBudgetAchievementRate = totalObj.goodsBudgetAchievementRate / obj.dailyRecords.length;
      for (let keyName in totalObj) {
        if (typeof(totalObj[keyName]) == "number" ) {
          totalObj[keyName] = totalObj[keyName].toLocaleString();
        }
      }
      totalObj.ticketBudgetAchievementRate = obj.dailyRecords[obj.dailyRecords.length - 1].ticketBudgetAchievementRate;
      totalObj.goodsBudgetAchievementRate = obj.dailyRecords[obj.dailyRecords.length - 1].goodsBudgetAchievementRate;

      newArr.push({
        attach: 1,
        dayDate: this.$locale("report.cinemaDaily.monthTotal"),
        ...totalObj,
      });

      newArr.push({
        attach: 2,
        freeMobilization: this.$locale("report.cinemaDaily.budget"),
        boxOfficeAmount: obj.budget.boxOffice.toLocaleString(),
        totalAmount: obj.budget.attached.toLocaleString(),
        dailyCash: this.$locale("report.cinemaDaily.monthEndSafeBalance"),
        preCash: obj.monthBalance.toLocaleString(),
      });

      newArr.push({
        attach: 3,
        freeMobilization: this.$locale("report.cinemaDaily.budgetDifference"),
        boxOfficeAmount: obj.budgetDifference.boxOffice.toLocaleString(),
        totalAmount: obj.budgetDifference.attached.toLocaleString(),
      });

      newArr.push({
        attach: 4,
        ticketBudgetAchievementRate: this.$locale("report.cinemaDaily.boxOfficeRatio"),
        programAmount: rounding(obj.boxOfficeAttachedRate.program * 100, "ROUND", 1, true) + "%",
        commercialAmount: rounding(obj.boxOfficeAttachedRate.commercial * 100 , "ROUND", 1, true)+ "%",
        concessionAmount: rounding(obj.boxOfficeAttachedRate.concession * 100, "ROUND", 1, true) + "%",
        membershipFreeAmount: rounding(obj.boxOfficeAttachedRate.membershipFree * 100, "ROUND", 1, true) + "%",
        otherAmount: rounding(obj.boxOfficeAttachedRate.other * 100, "ROUND", 1, true) + "%",
        totalAmount: rounding(obj.boxOfficeAttachedRate.total * 100, "ROUND", 1, true) + "%",
      });
      newArr.push({
        noHeaderData: true,
        attach: 5,
        dailyCash: this.$locale("report.cinemaDaily.numberByScreen"),
      });

      newArr.push({
        noHeaderData: true,
        attach: 6,
        dailyCash: this.$locale("report.cinemaDaily.screenName"),
        preCash: this.$locale("report.cinemaDaily.showTime"),
      });

      obj.houseSchedules.map(item => {
        newArr.push({
          noHeaderData: true,
          attach: 7,
          dailyCash: item.houseName,
          preCash: item.scheduleNumber.toLocaleString(),
        });
      });

      newArr.push({
        noHeaderData: true,
        attach: 8,
        dailyCash: this.$locale("report.cinemaDaily.monthTotal"),
        preCash: obj.monthScheduleNumber.toLocaleString(),
      });

      return newArr;
    },
  },
};
</script>

<style lang="less" scoped>
.cinema-daily-pdf-sample {
  // background-color: @other-grey;
  color: @pure-black;
  position: relative;
  line-height: 1.2;

  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  .page-top-point {
    display: block;
    height: 1px;
    outline: none;
    position: absolute;
    width: 1px;
  }

  .pager-ctrl-row {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;

    .el-button {
      padding: 10px 15px;
    }

    .el-button+.el-button {
      margin-left: 30px;
    }
  }

  .cinema-daily-page-container {
    background-color: @pure-white;
    // box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 840px;
    justify-content: flex-start;
    margin: 0 auto;
    position: relative;
    width: 1190px;

    > section {
      padding-left: 30px;
      padding-right: 30px;

      &:first-of-type {
        padding-top: 30px;
      }

      &:last-of-type {
        padding-bottom: 30px;
      }
    }

    .invoice-header {
      padding-bottom: 10px;

      h1 {
        border: 1px solid @primary-black;
        font-size: 16px;
        margin: 0 auto;
        padding: 2px 0;
        text-align: center;
        width: 150px;
      }

      .stamp-area {
        p {
          margin: 0;
        }

        .el-row {
          border: 1px solid @primary-black;
          margin-left: auto;
          margin-right: 0;
          text-align: center;
          width: 160px;

          .stamp-img {
            border-top: 1px solid @primary-black;
            height: 35px;
          }
        }
      }
    }

    .invoice-body {
      .invoice-deatils {
        ::v-deep .el-table {
          border-color: @primary-black;
          border-left: 0;

          &::before,
          &::after {
            display: none;
          }

          th {
            border-color: @primary-black;
            padding: 0;
            text-align: center;
            line-height: 1.2;
          }
          tbody .cell{
            text-align: right;
          }
          .cell {
            color: @primary-black;
            line-height: 1.2;
            font-size: 11px;
          }

          tr:first-child {
            th {
              &:nth-child(2),
              &:nth-child(3) {
                .cell {
                  padding: 0;
                  width: 2.5em;
                }
              }

              &:nth-child(5),
              &:nth-child(7) {
                .cell {
                  padding: 0;
                  width: 3.5em;
                }
              }

              &:nth-child(8) {
                .cell {
                  padding: 0;
                }
              }
            }
          }

          tr {
            border-left: 1px solid @primary-black;

            th:first-child {
              border-left: 1px solid @primary-black;
            }

            td {
              border-color: @primary-black;
              padding: 0;

              .cell {
                line-height: 1.2;
                overflow: hidden;
                padding: 0 1px;
                font-size: 11px;
              }

              &:nth-child(1) {
                border-left: 1px solid @primary-black;

                .cell {
                  height: 100%;
                  padding: 0 20px 0 0;
                  position: relative;
                  text-align: center;

                  span {
                    border-left: 1px solid @primary-black;
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 20px;
                  }
                }
              }
            }
          }

          tr.total1 {
            td:first-child {
              background-color: #898989;

              .cell {
                color: #fff;
                padding: 0;
              }
            }
          }

          tr.total2 {
            td {
              &:first-child {
                .cell {
                  text-align: left;
                }
              }

              &:nth-child(10) {
                border-right: 0;
                border-bottom: 0;
              }

              &:nth-child(11) {
                border-bottom: 0;
              }
            }
          }

          tr.total3 {
            td {
              &:first-child {
                .cell {
                  text-align: left;
                }
              }

              &:nth-child(10),
              &:nth-child(11),
              &:nth-child(12),
              &:nth-child(13) {
                border-right: 0;
                border-bottom: 0;
              }
            }
          }

          tr.total4 {
            td {
              &:first-child {
                .cell {
                  text-align: left;
                }
              }

              &:nth-child(8),
              &:nth-child(9),
              &:nth-child(10),
              &:nth-child(11) {
                border-right: 0;
                border-bottom: 0;
              }
            }
          }

          tr.total5 {
            border-left: 0;

            td {
              border: 0;

              &:last-child {
                border-bottom: 1px solid @primary-black;
              }

              .cell {
                text-align: left;
              }
            }
          }

          tr.total6,
          tr.total7,
          tr.total8 {
            border-left: 0;

            td {
              border: 0;

              &:nth-child(13) {
                border-right: 1px solid @primary-black;
              }

              &:nth-child(14),
              &:nth-child(15) {
                border-right: 1px solid @primary-black;
                border-bottom: 1px solid @primary-black;
              }
            }
          }
        }
      }
    }

    .invoice-footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      margin-top: 20px;
      box-sizing: border-box;

      .pagination {
        text-align: center;
        font-size: 14px;
      }
    }
  }

  .pdf-header-content {
    font-size: 12px;
    line-height: 1.2;
  }
}
</style>
